import {request, serviceUrl} from "@/utils/request";

//获取设备测点列表
export function listByDeviceId(deviceId) {
  return request({
    method: 'post',
    url: serviceUrl.deviceService + '/device/measuring-point/listByDeviceId',
    params: {
      deviceId
    }
  });
}
// 根据设备id列表获取设备测点列表
export function listByDeviceIdList(deviceId) {
  return request({
    method: 'post',
    url: serviceUrl.deviceService + '/device/measuring-point/listByDeviceIdList',
    data: deviceId
  });
}

//根据设备id 获取code 查询可操控的测点
export function getByModelIdFromDeviceId(deviceId) {
  return request({
    method: 'post',
    url: serviceUrl.deviceService + '/device/measuring-point/getByModelIdFromDeviceId',
    params: {
      deviceId
    }
  });
}

//对测点进行控制：修改测点的值
export function control(deviceId, modeControlId, value) {
  return request({
    method: 'post',
    url: serviceUrl.deviceService + '/device/measuring-point/control',
    params: {deviceId, modeControlId, value}
  });
}

//修改测点的值
export function controlPoint(pointId, value) {
  return request({
    method: 'post',
    url: serviceUrl.deviceService + '/device/measuring-point/control-point',
    params: {pointId, value}
  });
}

//修改测点信息
export function updateDeviceMeasuringPoint(params) {
  return request({
    method: 'post',
    url: serviceUrl.deviceService + '/device/measuring-point/update',
    data: params
  });
}


//批量修改测点信息
export function updatePointList(params) {
  return request({
    method: 'post',
    url: serviceUrl.deviceService + '/device/measuring-point/updateBatch',
    data: params
  });
}

//修改告警阈值
export function updateDeviceMeasuringPointAlarm(params) {
  return request({
    method: 'post',
    url: serviceUrl.deviceService + '/device/measuring-point/updateDeviceMeasuringPoint',
    data: params
  });
}

//批量修改告警阈值
export function updateDeviceMeasuringPointBatch(params) {
  return request({
    method: 'post',
    url: serviceUrl.deviceService + '/device/measuring-point/updateBatchDeviceMeasuringPoint',
    data: params
  });
}

//同步测点排序到相同型号
export function synchronousSorting(deviceId) {
  return request({
    method: 'post',
    url: serviceUrl.deviceService + '/device/measuring-point/synchronousSorting',
    params: {deviceId},
    timeout: 60000 * 30
  });
}

export function pointNameDistinguish(list, deviceTypeEngName) {
  console.log(deviceTypeEngName)
  // if (deviceTypeEngName == 'PM_GGD' || deviceTypeEngName == 'PM_GGDS') {  //精密配电柜
  //     console.log(list);
  //     for (var i = 0; i < list.length; i++) {
  //         console.log(list[i].code);
  //         if (list[i].code == 'ggd_m_sw' && (list[i].group == 1 || list[i].group == 0)) { //主路1
  //             list[i].name='主路1'+list[i].name;
  //         } else if (list[i].code == 'ggd_m_sw' && list[i].group == 2) { //主路2
  //             list[i].name='主路2'+list[i].name;
  //         }
  //         if (list[i].code == 'ggd_p_sw' && list[i].group == 0) { //主路1对应的支路
  //             list[i].name='主路1支路'+list[i].name;
  //         } else if (list[i].code == 'ggd_p_sw' && list[i].group == 1) { //主路1对应的支路
  //             list[i].name='主路1支路'+list[i].name;
  //         } else if (list[i].code == 'ggd_p_sw' && list[i].group == 2) { //主路2对应的支路
  //             list[i].name='主路2支路'+list[i].name;
  //         }
  //     }
  // }
  return list;
}
